// Variables
export const OD_Free = 0;
export const Wire_Dia = 1;
export const L_Free = 2;
export const Coils_T = 3;
export const Force_1 = 4;
export const Force_2 = 5;
export const Mean_Dia = 6;
export const Coils_A = 7;
export const Rate = 8;
export const Deflect_1 = 9;
export const Deflect_2 = 10;
export const L_1 = 11;
export const L_2 = 12;
export const L_Stroke = 13;
export const L_Solid = 14;
export const Slenderness = 15;
export const ID_Free = 16;
export const Weight = 17;
export const Spring_Index = 18;
export const Force_Solid = 19;
export const Stress_1 = 20;
export const Stress_2 = 21;
export const Stress_Solid = 22;
export const FS_2 = 23;
export const FS_Solid = 24;
export const FS_CycleLife = 25;
export const Cycle_Life = 26;
export const PC_Avail_Deflect = 27;
export const Energy = 28;
export const Spring_Type = 29;
export const Prop_Calc_Method = 30;
export const Material_Type = 31;
export const ASTM_Fed_Spec = 32;
export const Process = 33;
export const Material_File = 34;
export const Life_Category = 35;
export const Density = 36;
export const Torsion_Modulus = 37;
export const Hot_Factor_Kh = 38;
export const Tensile = 39;
export const PC_Tensile_Endur = 40;
export const PC_Tensile_Stat = 41;
export const Stress_Lim_Endur = 42;
export const Stress_Lim_Stat = 43;
export const End_Type = 44;
export const Inactive_Coils = 45;
export const Add_Coils_Solid = 46;
export const Catalog_Name = 47;
export const Catalog_Number = 48;
export const tbase010 = 49;
export const tbase400 = 50;
export const const_term = 51;
export const slope_term = 52;
export const tensile_010 = 53;

// Labels (Properties)
export const COMMENT = 0;
export const Contact_person = 1;
export const Company_name = 2;
export const Street = 3;
export const City__State___Zip = 4;
export const Phone___email = 5;
export const Date = 6;
export const Part_Number = 7;
export const Data_Source = 8;
export const Mandril = 9;
export const Wind = 10;
export const Shot_peen = 11;
export const Stress_relieve_HT = 12;
export const Pre_set = 13;
export const Finish = 14;
export const Squareness = 15;
export const End_use = 16;
export const Fits_in___Works_over = 17;
export const Operating_temp = 18;
export const Special_notes___tol = 19;
export const Customer_approval = 20;
export const Customer_date = 21;
export const Vendor_approval = 22;
export const Vendor_date = 23;